import { Model } from '@/services/api/lib'

class Settings extends Model {
  resource () {
    return 'settings/v1/settings'
  }

  primaryKey () {
    return 'code_url'
  }

  updateMethod () {
    return 'PUT'
  }

  async getPluginsList () {
    const { data } = await this.request({
      method: 'GET',
      url: `${this.endpoint()}/plugins`
    })

    return data
  }
}

class GeneralSettings extends Settings {
  resource () {
    return 'settings/v1/settings/general'
  }

  async getCloudinary () {
    const { data } = await this.request({
      method: 'GET',
      url: `${this.endpoint()}/cloudinary`
    })

    return {
      name: data.name || process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
      preset: data.preset || process.env.VUE_APP_CLOUDINARY_UPLOAD_PRESET
    }
  }
}

class ContactAddress extends GeneralSettings {
  constructor (...attributes) {
    super(...attributes)
    this.code_url = 'contact/address'
    this.validatorSchema = {
      'name': 'required|string',
      'street': 'required|string',
      'city': 'required|string',
      'region': 'string',
      'postcode': 'required|string',
      'country_code': 'required|string'
    }
  }

  validations () {
    return this.validatorSchema || {}
  }

  async save () {
    this.validatorSchema = {
      'data.name': 'required|string',
      'data.street': 'required|string',
      'data.city': 'required|string',
      'data.region': 'string',
      'data.postcode': 'required|string',
      'data.country_code': 'required|string'
    }

    return super.save()
  }
}

class Country extends Settings {
  resource () {
    return 'settings/v1/countries'
  }

  async getRegions (code) {
    if (!code) {
      return []
    }

    const { data } = await this.request({
      method: 'GET',
      url: `${this.endpoint()}/${code}/regions`
    })

    return data
  }
}

export {
  GeneralSettings,
  ContactAddress,
  Settings,
  Country
}
